export default "__VITE_ASSET__B1hRGAc9__"